import { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { uploadMobileFileApi } from "../../apis/mobile-upload.api";

const MobileUpload = () => {
  const { uploadId } = useParams();

  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);

  const upload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("uploadId", uploadId);
      formData.append("image", file);

      await uploadMobileFileApi(formData);

      setUploaded(true);
    } catch (e) {
      console.log(e);
      alert("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return uploaded ? (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        background: "#f5f5f5",
      }}
    >
      <Paper
        sx={{
          p: 4,
          textAlign: "center",
          width: 350,
        }}
      >
        <CheckCircleOutline color="success" sx={{ fontSize: 80 }} />

        <Typography variant="h5" mt={2}>
          Upload Successful
        </Typography>

        <Typography mt={2}>
          Your document has been uploaded successfully.
        </Typography>

        <Typography mt={1} color="text.secondary">
          You can now close this page.
        </Typography>
      </Paper>
    </Box>
  ) : (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
      }}
    >
      <Paper
        sx={{
          p: 4,
          width: 350,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" mb={2}>
          Upload Document
        </Typography>

        <Typography mb={3}>Capture a document using your phone.</Typography>

        <Button
          variant="contained"
          component="label"
          fullWidth
          disabled={loading}
        >
          Capture Photo
          <input
            hidden
            accept="image/*"
            capture="environment"
            type="file"
            onChange={upload}
          />
        </Button>

        {loading && (
          <Box mt={3} textAlign="center">
            <CircularProgress />
            <Typography mt={2}>Uploading...</Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default MobileUpload;
